import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  '.MuiCollapse-wrapperInner,.MuiCollapse-vertical': {
    position: 'relative',
  },

  /* Pseudo-element to create a short left border */
  '.MuiCollapse-wrapperInner::after': {
    content: '""',
    position: 'absolute',
    bottom: (p) => p.spacing(2.5),
    left: 0,
    height: 'calc(100% - 10px)',
    borderLeft: (p) => `1px solid ${p.palette.grey[400]}`,
  },

  '.MuiCollapse-vertical,.MuiCollapse-entered': {
    paddingLeft: (p) => p.spacing(0.5),
  },
};
